import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Shift } from 'src/app/core/models/flavor.model';

@Component({
  selector: 'app-shift-selection-modal',
  templateUrl: './shift-selection-modal.component.html',
  styleUrls: ['./shift-selection-modal.component.scss'],
})
export class ShiftSelectionModalComponent implements OnInit {
  public flavorShifts: Shift[]

  constructor(
    private dialogRef: MatDialogRef<ShiftSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.flavorShifts = this.data.flavorShifts;
  }

  public selectShift(shift: Shift): void {
    this.dialogRef.close(shift); 
  }

  private formatDateString(dateString: string): string {
    const [month, day, year] = dateString.split('-').map(num => parseInt(num, 10));
    const date = new Date(year, month - 1, day);

    const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

}
